import { COMPONENT_NAME } from '../constants';

import type { Logger } from '@web-platform/global-components-types/utils';

interface DecorateLoggerParams {
  experimentContext?: string;
  locale: string;
  logger: Logger;
  loginStep: string;
  market: string;
  regulatoryConsentRequired: string;
  screenName: string;
  source: string;
}

const decorateLogger = ({
  experimentContext = '',
  locale,
  logger,
  loginStep,
  market,
  regulatoryConsentRequired,
  screenName,
  source,
}: DecorateLoggerParams): Logger => {
  const commonFields = {
    experimentContext,
    locale,
    component: COMPONENT_NAME,
    loginStep,
    market,
    regulatoryConsentRequired,
    screenName,
    source,
  };

  return {
    logError: (error, optionalFields) =>
      logger.logError(error, {
        ...commonFields,
        ...optionalFields,
      }),
    logOperationalEvent: (fields) => logger.logOperationalEvent({ ...commonFields, ...fields }),
    logWarn: ({ component, ...fields }) => logger.logWarn({ ...commonFields, ...fields }),
  };
};

export default decorateLogger;
